export default __webpack_public_path__ + "static/media/model-registerstep-new-60-mweb.4faba920.png";